import axios from "axios";
import { DataResponse } from "models/common/responseObjects";
import { FrontEndSetting } from "models/daoModels/settings/FrontEndSettings";


export class SettingsApi {
    static GetStoreGroupSetting = async <T>(key: string) => axios.get<DataResponse<FrontEndSetting>>(`api/v1/Settings/GetStoreGroupSetting`, { params: { key } });
    static SetStoreGroupSetting = async <T>(payload: FrontEndSetting) => axios.post<DataResponse<boolean>>(`api/v1/Settings/SetStoreGroupSetting`, payload);
    
    static GetUserSetting = async <T>(key: string) => axios.get<DataResponse<FrontEndSetting>>(`api/v1/Settings/GetUserSetting`, { params: { key } });
    static SetUserSetting = async <T>(payload: FrontEndSetting) => axios.post<DataResponse<boolean>>(`api/v1/Settings/SetUserSetting`, payload);
}